// replace the all popups if such exist
export const REPLACE_POPUP = 'POPUP/REPLACE_POPUP';
// replace the active popup if such exists
export const REPLACE_ACTIVE_POPUP = 'POPUP/REPLACE_ACTIVE_POPUP';
export const PUSH_POPUP = 'POPUP/PUSH_POPUP';
export const CLOSE_ALL_POPUPS = 'POPUP/CLOSE_ALL_POPUPS';
// active is the last item in the array, the top visible popup
export const CLOSE_ACTIVE_POPUP = 'POPUP/CLOSE_ACTIVE_POPUP';
export const CLOSE_TARGET_POPUP = 'POPUP/CLOSE_TARGET_POPUP';
